var Login = function(){

	var validation = new Validation();
	var url_atual = window.location.href.replace('#', '');

	function init(){

	};

	$('#fbLogin').click(function (e){
		e.preventDefault();
		FB.login(function(response) {
			if (response.status === 'connected') {
				checkLoginState(1);
			} else if (response.status === 'not_authorized') {
				// The person is logged into Facebook, but not your app.
				console.log('not authorized');
			} else {
				// The person is not logged into Facebook.
				console.log('not logged');
			}
		}, {scope: 'public_profile,email'});
	});

	$('#fbRegister').click(function (e){
		e.preventDefault();
		FB.login(function(response) {
			if (response.status === 'connected') {
				checkLoginState(2);
			} else if (response.status === 'not_authorized') {
				// The person is logged into Facebook, but not your app.
				console.log('not authorized');
			} else {
				// The person is not logged into Facebook.
				console.log('not logged');
			}
		}, {scope: 'public_profile,email'});

	});

	$('[data-page="login"] .btn-login').on('click', function(e){
		e.preventDefault()

		var form = $('.form-login');

		if($(this).hasClass('btn-green'))
		{
			form.submit();
		}
	})

	$('.form-login .form-control').on('keyup', function(){
		validationFormLogin($(this));
	});

	// $(".form-login").on('submit', function(e) {
	// 	e.preventDefault();
    //     var form = $(this);
    //     TweenMax.fromTo($('.load'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
    //     $.ajax({
	// 		url: '/website/public/customer/login-login',
	// 		type: 'POST',
	// 		data: form.serialize(),
	// 		dataType: 'json',
	// 		success: function (result) {
	// 				if (result != null) {
	// 					if (result.success == true){
	// 	        	location.href = result.Mensagem;
	// 	        } else {
    //           alert('Erro!',result.Mensagem);
	// 	        }
	// 		    } else {
	// 		    	alert('Erro!. result está nulo');
	// 		    }
	// 		   TweenMax.fromTo($('.load'), 0.5, {css:{alpha:1,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
	// 		},
	// 		error: function (XMLHttpRequest, textStatus, errorThrown, result) {
	// 				console.log(result);
	// 				console.log(textStatus);
	// 		    console.log("Erro")
	// 		    TweenMax.fromTo($('.load'), 0.5, {css:{alpha:1,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
	// 		}
	// 	});
	// });

	function validationFormLogin(input)
	{
		var error = false;
    	var form = $('.form-login');

    	var login = form.find('[name="login"]');
    	var pass = form.find('[name="password"]');

    	var senhaMin = 4;

    	if (!validation.IsEmail(login.val()) || validation.isNull(login.val())) {
    		error = true;
    		if($(login).attr('id') == $(input).attr('id')){
    			login.addClass('error');
    		}
    	} else {
			login.removeClass('error');
    	}

    	if (pass.val().length < senhaMin || validation.isNull(pass.val())) {
    		error = true;
    		if($(pass).attr('id') == $(input).attr('id')){
    			pass.addClass('error');
    		}
    	} else {
    		pass.removeClass('error');
    	}

	};

	return init();
};
